import { render, staticRenderFns } from "./TrModal.vue?vue&type=template&id=2c3710a8&scoped=true&"
import script from "./TrModal.vue?vue&type=script&lang=js&"
export * from "./TrModal.vue?vue&type=script&lang=js&"
import style0 from "./TrModal.vue?vue&type=style&index=0&id=2c3710a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3710a8",
  null
  
)

export default component.exports